$(function() {
  if ($('#ckeditor').length === 0) return

  var editor = CKEDITOR.replace('ckeditor', {
    language: 'cs',
    extraPlugins: 'colorbutton,colordialog',
    contentsCss: '/css/sb-admin-2.css'
  })
  CKFinder.setupCKEditor(editor)
  CKFinder.widget('ckeditor', {
    language: 'cs'
  })

  CKEDITOR.instances.ckeditor.setData(window.content)

  // CKEDITOR.stylesSet.add('my_styles', [
  //   // Block-level styles
  //   { name: 'Blue Title', element: 'h2', styles: { color: 'Blue' } },
  //   { name: 'Red Title', element: 'h3', styles: { color: 'Red' } },

  //   // Inline styles
  //   { name: 'CSS Style', element: 'span', attributes: { class: 'my_style' } },
  //   { name: 'Marker: Yellow', element: 'span', styles: { 'background-color': 'Yellow' } }
  // ])

  // config.stylesSet = 'my_styles';

  CKEDITOR.addCss(`
    body {
      margin: 0;
      font-family: "Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #858796;
      text-align: left;
      background-color: #fff;
    }
  `)
})
